import { useCallback, useMemo } from 'react';
import { ButtonProps } from 'react-rainbow-components/components/Button';
import FlagIcon from 'components/icons/flag';
import Button from 'components/Button';
import useSendFeedback, { FeedbackType, FeedbackContext } from 'hooks/useSendFeedback';

interface ReportButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
    agentId: string;
    context: FeedbackContext;
    label?: string;
}

const getTitleFromType = (type: FeedbackType): string => {
    const titleMap: Record<FeedbackType, string> = {
        conversation: 'Report Conversation',
        message: 'Report Message',
        note: 'Report Note',
        'opportunity-summary': 'Report Opportunity Summary',
        call: 'Report Call',
    };
    return titleMap[type] || 'Report Issue';
};

const ReportButton = ({
    agentId,
    context,
    label = 'Report',
    ...buttonProps
}: ReportButtonProps) => {
    const { sendFeedback } = useSendFeedback();

    const title = useMemo(() => getTitleFromType(context.type), [context.type]);

    const handleClick = useCallback(() => sendFeedback({
        agentId,
        context,
        title,
    }), [agentId, context, title, sendFeedback]);

    return (
        <Button
            onClick={handleClick}
            size="small"
            variant="base"
            borderRadius="semi-square"
            {...buttonProps}
        >
            <FlagIcon className="rainbow-m-right_x-small" />
            {label}
        </Button>
    );
};

export default ReportButton;
